import {useTransitionInspectionMutation} from 'src/redux/queries/inspection';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {captureGeoResult} from 'src/app/inspections/geo/geoCapture';

export interface UseGeoTransitionResult {
  /** Captures geo (never blocks — falls back to a `geoNote`) then fires the transition. */
  runTransition: (transition: string, note?: string) => Promise<void>;
  isTransitioning: boolean;
}

// Geo is captured and sent with every transition but never gates it (D7).
export function useGeoTransition(inspectionId: number): UseGeoTransitionResult {
  const {setAlert} = useAlert();
  const [transitionInspection, {isLoading: isTransitioning}] =
    useTransitionInspectionMutation();

  const runTransition = async (transition: string, note?: string) => {
    const {latitude, longitude, geoNote} = await captureGeoResult();
    try {
      await transitionInspection({
        id: inspectionId,
        request: {transition, note, latitude, longitude, geoNote},
      }).unwrap();
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
    }
  };

  return {runTransition, isTransitioning};
}
